import { render, staticRenderFns } from "./modelFullRelease.vue?vue&type=template&id=4e7e5a70&scoped=true&"
import script from "./modelFullRelease.vue?vue&type=script&lang=js&"
export * from "./modelFullRelease.vue?vue&type=script&lang=js&"
import style0 from "./modelFullRelease.vue?vue&type=style&index=0&id=4e7e5a70&lang=scss&scoped=true&"
import style1 from "./modelFullRelease.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7e5a70",
  null
  
)

export default component.exports